<script>
    import {
        Table,
        InputGroup,
        InputGroupText,
        Form,
        Input,
    } from 'sveltestrap';

    export let slo;
</script>

<Table striped size="sm">
<!--    <thead>-->
<!--    <tr>-->
<!--        <th class="text-center">SLO</th>-->
<!--        <th class="text-center">&nbsp;</th>-->
<!--    </tr>-->
<!--    </thead>-->
    <tbody>
    <tr>
        <th class="text-center align-middle">SLO</th>
        <td class="text-center align-middle">
            <InputGroup class="w-25">
                <Input
                        type="number"
                        name="number"
                        id="slo"
                        placeholder="number placeholder"
                        bind:value={$slo}
                />
                <InputGroupText>%</InputGroupText>
            </InputGroup>
        </td>
        <td></td>
    </tr>
    </tbody>
</Table>
